import { preInsert, preRemove, preSave } from '@/rxdb/defaultHooks';
import defaultReplication from '@/rxdb/defaultReplication';

export const certificates = {
    schema: {
        title: 'certificates schema',
        version: 2,
        description: 'describes a certificate',
        primaryKey: 'id',
        type: 'object',
        properties: {
            id: { type: 'string', final: true, maxLength: 40 },
            projectId: { type: ['string', 'null'] },
            bundleId: { type: ['string', 'null'] },
            serviceId: { type: ['string', 'null'] },
            emitterId: { type: ['string', 'null'] },
            name: { type: ['string', 'null'] },
            code: { type: ['string', 'null'] },
            object: { type: ['string', 'null'] },
            emissionDueDate: { type: ['string', 'null'] },
            emissionDate: { type: ['string', 'null'] },
            locationIds: { type: ['array', 'null'], items: { type: 'string' } },
            reportedBy: { type: ['string', 'null'] },
            obsoleteBy: { type: ['string', 'null'] },
            obsoleteAt: { type: ['string', 'null'] },
            obsoleteComment: { type: ['string', 'null'] },
            attachments: {
                type: ['array', 'null'],
                items: {
                    type: 'object',
                    properties: {
                        fileName: { type: ['string', 'null'] },
                        url: { type: ['string', 'null'] },
                    },
                },
            },
            predecessors: {
                type: 'array',
                items: {
                    type: 'object',
                    properties: {
                        type: { type: 'string' },
                        delay: { type: 'number' },
                        taskId: { type: 'string' },
                    },
                },
            },
            createdBy: { type: ['string', 'null'], final: true },
            updatedAt: { type: ['string', 'null'] },
            deletedAt: { type: ['string', 'null'] },
            deletedBy: { type: ['string', 'null'] },
            createdAt: { type: ['string', 'null'] },
            updatedBy: { type: ['string', 'null'] },
            rootVersion: { type: ['string', 'null'] },
        },
    },
    options: {
        onCollectionCreated(projectId, rxCollection) {
            rxCollection.replicationState = defaultReplication(rxCollection, projectId);
            rxCollection.preRemove(preRemove, false);
            rxCollection.preInsert(preInsert, false);
            rxCollection.preSave(preSave, false);
        },
    },
    migrationStrategies: {
        1: (doc) => ({ ...doc, predecessors: [] }),
        2: (doc) => doc,
    },
};
